module.exports = __webpack_public_path__ + "nKKZ-Go6G5tXcrabGwCYdA1.980fba5e060978e72db4.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/thana/Documents/sdc-nida-front_2024/backoffice/src/css/nKKZ-Go6G5tXcrabGwCYdA1.woff2
// module id = ../../../../../src/css/nKKZ-Go6G5tXcrabGwCYdA1.woff2
// module chunks = styles